<div class="position-relative">
    <div class="d-flex align-items-center justify-content-center certificate-loader">
        <div>
            <img class="mx-auto loader-gif" src="assets/images/upgradRed/upgradLoader.gif" style="margin: 0 auto;">
            <!-- <div>Your report is downloading...</div> -->
        </div>
    </div>
</div>